import {Directive, HostListener} from '@angular/core';
import * as screenfull from 'screenfull';

@Directive({
    selector: '[appToggleFullScreen]',
    standalone: false
})
export class ToggleFullScreenDirective {
  @HostListener('click') onClick() {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
  }

}
